var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusSolutionsLogoReverse01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 274.068,
    height: 39.535,
    viewBox: "0 0 274.068 39.535",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.b{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8.209 -5.373)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M550.283,36.818a37.309,37.309,0,0,0-5.142-.578c-2.751,0-5.789.874-5.789,4.114,0,3.171,4.09,4.292,4.341,5.235-.044.5-.864.484-1.22.484a10.746,10.746,0,0,1-4.085-.993l.484,4.658a15.762,15.762,0,0,0,4.05.677h1.541c2.534,0,5.754-1.343,5.754-4.277,0-3.042-4.341-4.238-4.341-5.24,0-.316,1.3-.385,1.541-.385a9.507,9.507,0,0,1,3.181.642Z",
    transform: "translate(-268.323 -15.622)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M509.7,36.655h-6.431c-.128,4.475-.346,8.89-.869,13.34h6.589c.123-1.743-.119-8.678,2.573-8.678,1.254,0,1.289,1.788,1.289,2.667,0,2-.385,4.03-.321,6.011h6.495c-.054-3.28.449-6.544.449-9.8,0-2.934-2.415-3.951-5.013-3.951a7.161,7.161,0,0,0-4.82,1.768Z",
    transform: "translate(-250.108 -15.622)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M475.879,40.344c1.19,0,1.734,1.141,1.734,2.183a3.062,3.062,0,0,1-1.18,2.628,1.342,1.342,0,0,1-.494.2H475.3c-.835,0-1.447-1.255-1.447-1.961v-.612a2.25,2.25,0,0,1,2.03-2.44m.064-4.564c-4.435,0-8.614,2.489-8.614,7.33,0,4.741,4.124,6.846,8.387,6.846,4.495,0,8.357-2.381,8.357-7.265,0-4.578-3.946-6.91-8.13-6.91",
    transform: "translate(-232.359 -15.389)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M453.586,26.8a22.435,22.435,0,0,0-.059,3.052v.578H459.7a20.341,20.341,0,0,1,.257-3.63Z",
    transform: "translate(-225.362 -10.844)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M452.261,36.56c-.1,4.48-.3,8.885-.741,13.34h6.944a101.937,101.937,0,0,1,.484-13.34Z",
    transform: "translate(-224.358 -15.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M438.2,37.248l.064-4.529h-2.637l.163-3.759-6.11,1.348-.193,2.41h-2.311l-.257,4.529H429.1c-.163,1.635-.356,3.443-.356,5.077,0,2.741,1.23,4.178,4.08,4.178h1.348a13.718,13.718,0,0,0,3.309-.578l.869-4.529a5.386,5.386,0,0,1-1.8.351c-1.417,0-1.255-1.161-1.255-2.218a12.161,12.161,0,0,1,.123-2.287H438.2Z",
    transform: "translate(-211.908 -11.938)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M402.075,49.9h6.11a96.4,96.4,0,0,1,.805-13.34h-6.431c-.267,1.65.538,8.614-2.094,8.614-.83,0-1.126-.612-1.126-1.383V42.25c0-1.882.375-3.808.484-5.69H393.3c-.138,3.205-.548,6.485-.548,9.676,0,3.329,2.272,4.114,5.206,4.114a5.391,5.391,0,0,0,4.114-1.961V49.9Z",
    transform: "translate(-194.615 -15.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M377.352,27.46c-.4,5.942-.608,11.888-1.062,17.835h6.594c.158-5.947.459-11.913,1.057-17.835Z",
    transform: "translate(-186.284 -11.178)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M349.769,40.344a1.961,1.961,0,0,1,1.768,2.183,3.049,3.049,0,0,1-1.21,2.628,1.342,1.342,0,0,1-.494.2h-.642c-.84,0-1.413-1.255-1.413-1.961v-.612a2.194,2.194,0,0,1,1.99-2.44m.064-4.564c-4.43,0-8.614,2.489-8.614,7.33,0,4.727,4.144,6.846,8.391,6.846,4.49,0,8.352-2.381,8.352-7.265,0-4.578-3.951-6.91-8.13-6.91",
    transform: "translate(-168.536 -15.389)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M324.985,26.868a50.021,50.021,0,0,0-5.171-.578c-3.186,0-7.394,1.2-7.394,5.077,0,4.332,5.882,6.194,5.882,7.814,0,.81-1.329.805-1.862.805a13.926,13.926,0,0,1-4.82-1.027l.479,5.369a24.707,24.707,0,0,0,5.142.578c3.7,0,8.036-1.111,8.036-5.626,0-3.759-6.07-5.784-5.789-7.488.346-.642,1.284-.642,1.931-.642a10.02,10.02,0,0,1,3.951.869Z",
    transform: "translate(-153.555 -10.586)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M288.163,36.333a37.926,37.926,0,0,0-5.176-.543c-2.731,0-5.754.854-5.754,4.08s4.04,4.292,4.307,5.24c-.044.5-.83.484-1.19.484a9.927,9.927,0,0,1-4.08-.963l.479,4.662a16.006,16.006,0,0,0,4.015.677h1.541c2.524,0,5.784-1.343,5.784-4.277,0-2.637-2.756-3.447-4.307-4.949a.907.907,0,0,1-.064-.321c0-.262,1.324-.356,1.541-.356a9.557,9.557,0,0,1,3.215.642Z",
    transform: "translate(-135.665 -15.394)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M252.135,49.9h6.139a96.44,96.44,0,0,1,.8-13.34h-6.426c-.262,1.615.494,8.614-2.089,8.614-.835,0-1.126-.612-1.126-1.383V42.25c0-1.882.375-3.808.484-5.69h-6.559c-.133,3.205-.548,6.485-.548,9.676,0,3.319,2.237,4.114,5.176,4.114a5.249,5.249,0,0,0,4.144-1.961V49.9Z",
    transform: "translate(-118.731 -15.784)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M229.661,36.723l.1-4.5h-2.667l.158-3.793-6.1,1.383-.163,2.41h-2.346l-.227,4.5h2.153c-.163,1.63-.321,3.443-.321,5.077,0,2.781,1.2,4.178,4.08,4.178h1.348a13.523,13.523,0,0,0,3.28-.578l.864-4.5a6.844,6.844,0,0,1-1.64.321c-1.442,0-1.413-.711-1.413-1.926a18.649,18.649,0,0,1,.158-2.573Z",
    transform: "translate(-106.382 -11.669)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M187.965,40.621a25.079,25.079,0,0,1,5.784-1.22c.593-.04.953.123,1.062.741l-.193.356c-2.376,1.719-8.678-.133-8.678,5.947,0,2.884,3.561,3.536,5.724,3.536a9.058,9.058,0,0,0,1.319-.094l1.092-3.793a1.669,1.669,0,0,1-.805.158c-.43,0-.963.03-.963-.543,0-.869,2.074-1.067,2.667-1.383-.123,1.724-.336,3.487-.42,5.206h6.366c-.094-3.452.484-6.9.484-10.347,0-2.721-3.551-3.373-5.626-3.373a51.9,51.9,0,0,0-7.167.864Z",
    transform: "translate(-89.949 -15.404)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M174.266,36.723l.064-4.5h-2.667l.193-3.793-6.1,1.383-.193,2.41h-2.311l-.257,4.5h2.183c-.163,1.63-.321,3.443-.321,5.077,0,2.756,1.18,4.178,4.05,4.178h1.348a13.481,13.481,0,0,0,3.309-.578l.869-4.5a6.618,6.618,0,0,1-1.674.321c-1.561,0-1.383-.948-1.383-2.183a16.492,16.492,0,0,1,.158-2.316h2.736Z",
    transform: "translate(-78.334 -11.669)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M148.17,26.868a49.964,49.964,0,0,0-5.176-.578c-3.181,0-7.359,1.21-7.359,5.077,0,4.3,5.848,6.218,5.848,7.814,0,.815-1.319.805-1.862.805a13.975,13.975,0,0,1-4.821-1.027l.479,5.369a24.67,24.67,0,0,0,5.142.578c3.709,0,8.065-1.092,8.065-5.626,0-3.759-6.07-5.784-5.784-7.488.346-.642,1.279-.642,1.926-.642a10.14,10.14,0,0,1,3.922.869Z",
    transform: "translate(-64.067 -10.586)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M91.8,34.19l-13.913-3.1.044-.543L92.84,28.13A15.785,15.785,0,0,1,91.8,34.19",
    transform: "translate(-35.265 -11.517)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M89.056,11.82,78.3,20.3l-.128.677L92.5,16.887a10.363,10.363,0,0,0-3.443-5.067",
    transform: "translate(-35.407 -3.263)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M81,5.58,78.65,15.394l8.2-8.268A16.1,16.1,0,0,0,81,5.58",
    transform: "translate(-35.65 -0.105)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M44.3,5.376l.04,9.592a25.008,25.008,0,0,0-5.458-.563c-3.581-.025-9.453,1.087-10.249,5.917-.805,4.914,6.687,7.473,4.949,9.493C31.561,32.171,13.4,24.263,13.4,24.263A37.62,37.62,0,0,1,27.649,10.538C37.438,5.05,44.3,5.376,44.3,5.376",
    transform: "translate(-2.627 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M9.247,50.38,23.16,53.487l-.044.543L8.209,56.45a15.741,15.741,0,0,1,1.037-6.07",
    transform: "translate(0 -22.778)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M12.628,69.587l10.762-8.48.128-.677L9.19,64.52a10.31,10.31,0,0,0,3.438,5.067",
    transform: "translate(-0.497 -27.864)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M26.968,75.159l2.351-9.809-8.2,8.263a16.009,16.009,0,0,0,5.848,1.546",
    transform: "translate(-6.534 -30.354)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M40.35,59.924l-.04-9.587a25.008,25.008,0,0,0,5.458.563c3.576.02,9.453-1.087,10.244-5.917.805-4.914-6.687-7.473-4.949-9.493,2.025-2.356,20.186,5.551,20.186,5.551A37.7,37.7,0,0,1,57,54.773c-9.784,5.477-16.65,5.151-16.65,5.151",
    transform: "translate(-16.246 -15.021)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSolutionsLogoReverse01);
export default __webpack_public_path__ + "static/media/Status_Solutions_Logo-reverse-01.046178f429bc738cbd22323e81b91153.svg";
export { ForwardRef as ReactComponent };